module.exports = __webpack_public_path__ + "img/lib_region_flag_nu.5b22665d.png";